import { render, staticRenderFns } from "./base-chart.vue?vue&type=template&id=5cd0f151&scoped=true&"
import script from "./base-chart.vue?vue&type=script&lang=ts&"
export * from "./base-chart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd0f151",
  null
  
)

export default component.exports